import { Base64 } from 'js-base64'

function encode(obj) {
  return Base64.encodeURI(JSON.stringify(obj))
}
function decode(str) {
  return JSON.parse(Base64.decode(str))
}

export function serializeDeck(deck) {
  return encode(deck.map(card => [card.name, card.num]))
}
export function deserializeDeck(str) {
  return decode(str).map(arr => { return { name: arr[0], num: arr[1] } })
}

export function serializeCombinations(combs) {
  return encode(combs.filter(g => g.some(i => i !== '')))
}
export function deserializeCombinations(str) {
  return decode(str)
}

export default {
  serializeDeck,
  deserializeDeck,
  serializeCombinations,
  deserializeCombinations,
}